<script lang="ts">
	import Button, { Label as ButtonLabel, Icon as ButtonIcon } from '@smui/button/styled';
	import Chip, { Text as ChipText, TrailingIcon as ChipIcon } from '@smui/chips/styled';
	import Dialog, { Title, Content, Actions, InitialFocus } from '@smui/dialog/styled';
	import { getClient, mutate } from 'svelte-apollo';

	import { createEventDispatcher } from 'svelte';
	import LoadingOverlay from '../components/LoadingOverlay.svelte';
	import {
		removeMixedSegmentFromAdForm,
		importMixedSegmentToAdForm,
		removeSegmentFromAdForm,
		importSegmentToAdForm
	} from '../graphql/queries/segments';
	import type { DocumentNode } from 'graphql';

	export let mixed = false;
	let dispatch = createEventDispatcher();
	function dispatchSuccess() {
		dispatch('dispatchSuccess');
	}
	let removeSegmentDef: DocumentNode;
	let importSegmentDef: DocumentNode;

	if (mixed) {
		removeSegmentDef = removeMixedSegmentFromAdForm;
		importSegmentDef = importMixedSegmentToAdForm;
	} else {
		removeSegmentDef = removeSegmentFromAdForm;
		importSegmentDef = importSegmentToAdForm;
	}

	const client = getClient();

	let infoDialog = false;
	let successDialog = false;
	let errorDialog = false;
	let errorMessage: string;
	let successMessage: string;
	let loading = false;
	export let id: string;
	export let name: string;
	export let isActive: boolean;

	function handleError(errMsg: string) {
		errorMessage = errMsg;
		errorDialog = true;
		console.error('Error deleting segment', errMsg);
	}

	const toggleSegmentMutation = (mutation: DocumentNode) => {
		loading = true;
		return new Promise((resolve) =>
			mutate(client, {
				mutation: mutation,
				variables: {
					seg_id: id
				},
				errorPolicy: 'all'
			})
				.then((responseData) => {
					loading = false;
					const { errors, data } = responseData;
					if (errors) {
						console.log(errors);

						handleError(errors[0].message);
					} else {
						console.log('data', data);

						const successData = data.deleteSegmentFromAdform || data.importSegmentToAdform;
						successMessage = successData.message;
						successDialog = true;

						// dispatchSuccess();
					}
				})
				.catch((err) => {
					loading = false;
					handleError(err.message);
					resolve({ errors: err });
				})
		);
	};
</script>

{#if isActive}
	<Chip chip="adformOkChip" class="adformOkChip" on:click={() => (infoDialog = true)}>
		<ChipIcon class="material-icons" leading>check</ChipIcon>
		<ChipText>In Adform</ChipText>
	</Chip>
{:else}
	<Chip chip="adformOkChip" class="adformAddChip" on:click={() => (infoDialog = true)}>
		<ChipIcon class="material-icons" leading>add</ChipIcon>
		<ChipText>Add</ChipText>
	</Chip>
{/if}

<Dialog
	open={infoDialog}
	aria-labelledby="dialog-title"
	aria-describedby="dialog-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-title">AdForm Status</Title>
	<Content id="dialog-content">
		<b>{name}</b>
		segment is
		<b>{isActive ? '' : 'NOT'}</b>
		stored in AdForm.
	</Content>

	<Actions>
		<div>
			{#if isActive}
				<Button
					on:click={() => {
						toggleSegmentMutation(removeSegmentDef);
						infoDialog = false;
					}}
				>
					<ButtonLabel>Remove from AdForm</ButtonLabel>
					<ButtonIcon class="material-icons">delete_forever</ButtonIcon>
				</Button>
			{:else}
				<Button
					on:click={() => {
						toggleSegmentMutation(importSegmentDef);
						infoDialog = false;
					}}
				>
					<ButtonLabel>Send to AdForm</ButtonLabel>
					<ButtonIcon class="material-icons">add</ButtonIcon>
				</Button>
			{/if}
			<Button use={[InitialFocus]} variant="raised" on:click={() => (infoDialog = false)}
				>Close</Button
			>
		</div>
	</Actions>
</Dialog>

<Dialog
	open={successDialog}
	aria-labelledby="dialog-title"
	aria-describedby="dialog-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-title">Successful request for segment '{name}'</Title>
	<Content id="dialog-content">{successMessage}</Content>

	<Actions>
		<Button
			on:click={() => {
				successDialog = false;
				dispatchSuccess();
			}}
		>
			Close
		</Button>
	</Actions>
</Dialog>

<Dialog
	open={errorDialog}
	aria-labelledby="dialog-title"
	aria-describedby="dialog-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-title">Error deleting segment</Title>
	<Content id="dialog-content">{errorMessage}</Content>

	<Actions>
		<Button on:click={() => (errorDialog = false)}>Close</Button>
	</Actions>
</Dialog>

<LoadingOverlay title="Sending request to AdForm..." spinner visible={loading} />

<style>
	:global(.adformOkChip) {
		background-color: var(--color-success);
	}
	:global(.adformAddChip) {
		background-color: #eee;
		color: #aaa;
	}

	:global(.adformAddChip .mdc-chip__icon) {
		color: #aaa;
	}
</style>
